import * as actionTypes from './actionTypes';

const initState = {
    isSignUp : false
  }

const signUpReducer = function(state = initState, action){
    const response = action.response;
    switch(action.type){
        case actionTypes.SIGN_UP_USER_SUCCESS:
            return { ...state,isSignUp :true, response };
        case actionTypes.SIGN_UP_USER_ERROR:
            return { ...state,isSignUp :false, response };
        default:
            return state;
    }
}
export default signUpReducer;